import assembleURLHash from '../Base/route/assembleURLHash';

export default function saveAsNewRecord(paramData) {
    this.rest.fetchData('saveDeletedAsNewRecord', 'POST', paramData).then((returnData) => {
        const url = assembleURLHash('detail', paramData.module, returnData.data);
        window.location.replace(url);
    });
}
